import type { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import {
  CapturedEventSource,
  CapturedEventStatus,
  KillswitchFeature,
} from 'src/constants/payments-ops/enums'

const WEBHOOK_SOURCES = [
  CapturedEventSource.AchWebhook,
  CapturedEventSource.CardWebhook,
  CapturedEventSource.InstantPaymentWebhook,
]

export const isReplayableStatus = (status: CapturedEventStatus): boolean => {
  return status === CapturedEventStatus.Pending || status === CapturedEventStatus.ReplayFailed
}

export const isDiscardableStatus = (status: CapturedEventStatus): boolean => {
  return status === CapturedEventStatus.Pending
}

/** A replay while the switch that captured the event is still on is simply captured again. */
export const killswitchFeatureForSource = (source: CapturedEventSource): KillswitchFeature => {
  return WEBHOOK_SOURCES.includes(source)
    ? KillswitchFeature.Webhooks
    : KillswitchFeature.PaymentProcessing
}

/** MUI X v8 selection is `{ type, ids: Set }`, not an array. */
export const emptySelection = (): GridRowSelectionModel => {
  return { type: 'include', ids: new Set() }
}

/**
 * The selected row ids, limited to rows that are still selectable (a switch can turn on, or a
 * refetch can change a status, after the box was ticked) and in table order.
 */
export const resolveSelectedIds = (
  model: GridRowSelectionModel,
  selectableIds: string[],
): string[] => {
  return selectableIds.filter((rowId) => {
    const isListed = model.ids.has(rowId)

    return model.type === 'include' ? isListed : !isListed
  })
}

/** The replay endpoints answer with `{ message }` (bulk) or the event / nothing (single). */
export const resolveReplayMessage = (result: unknown): string => {
  if (typeof result !== 'object' || result === null || !('message' in result)) {
    return ''
  }

  return typeof result.message === 'string' ? result.message : ''
}
